import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import HeadData from 'components/Common/HeadData'
import { isTourPurchasable } from 'selectors/TourV2/tourV2OfferPageSelectors'

interface Props {
  offer: App.Tours.TourV2Offer
  variation: App.Tours.TourV2OfferVariation
}

function TourV2HeadData(props: Props) {
  const { offer, variation } = props
  const intl = useIntl()

  const description = intl.formatMessage(
    {
      id: '_bIl-J2mRxWqlY-MytMK',
      defaultMessage: '{variationDescription}. Book now with Luxury Escapes.',
      description: 'Meta description combining tour variation description with booking call-to-action',
    },
    { variationDescription: variation.description },
  )
  const image = variation.images[0]?.id
  const imageAlt = image && variation.name
  const title = `${variation.name} | Luxury`

  const purchasable = useMemo(() => isTourPurchasable(offer), [offer])

  return <HeadData
    title={title}
    noIndex={!purchasable}
    description={description}
    imageId={image}
    imageAlt={imageAlt}
  />
}

export default TourV2HeadData
